import * as mutationType from "../mutation_types";
import moment from "moment";

const state = {
  list: [],
  outstanding: {},
  library: [],
  schedule: {},
  resource: {}
};

const getters = {
  list: state => state.list,
  outstanding: state => state.outstanding,
  library: state => state.library,
  schedule: state => state.schedule,
  resource: state => state.resource
};

const actions = {
  getResources({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/resources")
        .then(res => {
          commit(mutationType.SET_RESOURCES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOutstandingResources({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/resources/outstanding")
        .then(res => {
          commit(mutationType.SET_OUTSTANDING_RESOURCES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getLibraryResources({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/resources/library")
        .then(res => {
          commit(mutationType.SET_RESOURCES_LIBRARY, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getResource({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit(mutationType.SET_RESOURCE, {});
      if (!id) {
        commit(mutationType.SET_RESOURCE, {});
        resolve();
      } else {
        this._vm.$http
          .get("/api/resources/" + id)
          .then(res => {
            commit(mutationType.SET_RESOURCE, res.data);
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      }
    });
  },
  saveResource({ commit }, resource) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/resources", resource)
        .then(res => {
          commit(
            mutationType.SET_RESOURCE,
            Object.assign(resource, { id: res.data })
          );
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteResource({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/resources/${id}`)
        .then(() => {
          commit(mutationType.DELETE_RESOURCE, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getResourceSchedules({ commit }, resourceId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/resources/${resourceId}/schedules`)
        .then(res => {
          commit(mutationType.SET_RESOURCE_SCHEDULES, {
            resourceId,
            list: res.data
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveFavorite({ commit }, favorite) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/resources/" + favorite.id + "/favorite/" + favorite.value)
        .then(() => {
          commit(mutationType.SET_RESOURCE_FAVORITE, favorite);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getResourceSchedule({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit(mutationType.SET_RESOURCE_SCHEDULE, {});
      if (!item.id) {
        commit(mutationType.SET_RESOURCE_SCHEDULE, {
          sendDate: moment().format("YYYY-MM-DD"),
          allMembers: true
        });
        resolve();
      } else {
        this._vm.$http
          .get(`/api/resources/${item.resourceId}/schedules/${item.id}`)
          .then(res => {
            commit(mutationType.SET_RESOURCE_SCHEDULE, res.data);
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      }
    });
  },
  saveResourceSchedule({ commit }, schedule) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/resources/${schedule.resourceId}/schedules`, schedule)
        .then(res => {
          commit(
            mutationType.SET_RESOURCE_SCHEDULE,
            Object.assign(schedule, { id: res.data })
          );
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteResourceSchedule({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/resources/${item.resourceId}/schedules/${item.id}`)
        .then(() => {
          commit(mutationType.DELETE_SCHEDULED_RESOURCE, item);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_RESOURCES](state, list) {
    state.list = list;
  },
  [mutationType.SET_OUTSTANDING_RESOURCES](state, item) {
    state.outstanding = item;
  },
  [mutationType.SET_RESOURCES_LIBRARY](state, list) {
    state.library = list;
  },
  [mutationType.SET_RESOURCE_FAVORITE](state, favorite) {
    let index = state.list.findIndex(cv => cv.id == favorite.id);
    if (index >= 0) {
      state.list[index].isFavorite = favorite.value;
    }
  },
  [mutationType.SET_RESOURCE_SCHEDULE](state, schedule) {
    state.schedule = schedule;
    let index = state.list.findIndex(cv => cv.id == schedule.resourceId);
    if (index >= 0) {
      if (!state.list[index].schedules) {
        state.list[index].schedules = [];
      }
      let sIndex = state.list[index].schedules.findIndex(
        x => x.id == schedule.id
      );
      if (sIndex < 0) {
        state.list[index].schedules.push(schedule);
        state.list[index].scheduledCount++;
      }
    }
  },
  [mutationType.DELETE_SCHEDULED_RESOURCE](state, item) {
    let index = state.list.findIndex(cv => cv.id == item.resourceId);
    if (index >= 0) {
      let sIndex = state.list[index].schedules.findIndex(x => x.id == item.id);
      if (sIndex >= 0) {
        state.list[index].schedules.splice(sIndex, 1);
        state.list[index].scheduledCount--;
      }
    }
  },
  [mutationType.SET_RESOURCE](state, resource) {
    state.resource = resource;
  },
  [mutationType.DELETE_RESOURCE](state, id) {
    let index = state.list.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  [mutationType.SET_RESOURCE_SCHEDULES](state, item) {
    let index = state.list.findIndex(cv => cv.id == item.resourceId);
    if (index >= 0) {
      this._vm.$set(state.list[index], "schedules", item.list);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
